import styled from 'styled-components';

export const Col = styled.div<{ width: number; centerAlign?: boolean }>`
  display: flex;
  width: ${(props) => props.width}px;
  flex-direction: column;
  text-align: ${(props) => (props.centerAlign ? 'center' : 'left')};
  flex-wrap: wrap;

  word-wrap: break-word;
`;
